import type { AllowedFilterOperator } from '@wix/wix-data-schema-types'
import type { LabeledFilterCondition } from '../../filterCondition'
import { FilterCondition } from '../../filterCondition'

const QUERY_OPERATOR_TO_FILTER_CONDITION_TYPES: Record<
  AllowedFilterOperator,
  FilterCondition[]
> = {
  eq: [FilterCondition.EQUALS, FilterCondition.IS_EMPTY],
  ne: [FilterCondition.NOT_EQUALS, FilterCondition.IS_NOT_EMPTY],
  gt: [FilterCondition.GREATER_THAN],
  gte: [FilterCondition.GREATER_THAN_OR_EQUAL],
  lt: [FilterCondition.LESS_THAN],
  lte: [FilterCondition.LESS_THAN_OR_EQUAL],
  contains: [FilterCondition.CONTAINS, FilterCondition.NOT_CONTAINS],
  endsWith: [FilterCondition.ENDS_WITH],
  startsWith: [FilterCondition.STARTS_WITH],
  hasSome: [FilterCondition.INCLUDES_ANY, FilterCondition.EXCLUDES_ANY],
  hasAll: [FilterCondition.INCLUDES_ALL, FilterCondition.EXCLUDES_ALL],
  urlized: [],
  exists: [FilterCondition.EXISTS],
}

const queryOperatorToConditionTypes = (
  operator: AllowedFilterOperator,
): FilterCondition[] => QUERY_OPERATOR_TO_FILTER_CONDITION_TYPES[operator]

const getAllowedConditionTypes = (queryOperators: AllowedFilterOperator[]) =>
  new Set<FilterCondition>(
    queryOperators.flatMap(queryOperatorToConditionTypes),
  )

export const getAllowedConditions = (
  conditions: LabeledFilterCondition[] = [],
  operators: AllowedFilterOperator[] | undefined,
): LabeledFilterCondition[] => {
  if (!operators) {
    return conditions
  }

  const allowedConditionTypes = getAllowedConditionTypes(operators)

  return conditions.filter(({ value }) => allowedConditionTypes.has(value))
}
